<template>
    <div class="report-list-filters">
        <div class="report-item report-filter-options">
            <p>Filtruj przypadki</p>

            <div class="report-item__filter--owner">
                <button @click="setCaseisReporter('')" class="report-item__badge report-item__badge--all">
                    <IconFileSearch class="report-item__icon" alt="" />
                    Wszystkie
                </button>
                <button @click="setCaseisReporter('true')" class="report-item__badge report-item__badge--my">
                    <IconFileSearch class="report-item__icon" alt="" />
                    Moje
                </button>
               <button @click="setCaseisReporter('false')" class="report-item__badge report-item__badge--other">
                   <IconFileSearch class="report-item__icon" alt="" />
                   Inne
               </button>
            </div>

           <div class="report-item__filter--gender">
               <label for="filter-gender-female">
                   <input
                       type="checkbox"
                       :checked="filter.patientGender.includes('K')"
                       @input="setGender('K')"
                       id="filter-gender-female"
                   />
                   <div class="checkbox checkbox--small"></div>
                   <span>KOBIETY</span>
               </label>

               <label for="filter-gender-male">
                   <input
                       type="checkbox"
                       :checked="filter.patientGender.includes('M')"
                       @input="setGender('M')"
                       id="filter-gender-male"
                   />
                   <div class="checkbox checkbox--small"></div>
                   <span>MĘŻCZYŹNI</span>
               </label>
           </div>

           <div class="report-item__filter--sort">
               <p>Sortuj według:</p>
               <select v-model="sort.field" @input="$emit('sort', sort.field)">
                   <option value="">Domyślnie</option>
                   <option value="case.number">Przypadek</option>
                   <option value="doctor.pwz">Nr PWZ</option>
                   <option value="case.createdAt">Data zgłoszenia</option>
                   <option value="case.surgicalEvaluation.code">Kod oceny chirurgicznej</option>
                   <option value="case.expectedSurgeryDate">Przewidywana data zabiegu</option>
                   <option value="case.chemotherapyEffectiveness">Ocena skuteczności chemioterapii</option>
                   <option value="case.lastChemotherapyCycleAt">Data zakończenia ostatniego cyklu chemii</option>
                   <option value="case.procedureRisk.code">Radykalność zabiegu</option>
               </select>
           </div>

            <div class="report-item__filter--search">
                <p>DIKOM:</p>
                <input v-model="folderId" @input="setFolderId()" />
            </div>
        </div>
        <div class="report-item">
            <div class="report-item__column report-item__column--case">
                <div class="report-item__filter-title">Przypadek</div>
                <div class="report-item__filter">
                    <input type="text" class="report-list__field" v-model="filter.caseNumber" @input="emitToParent" />
                    <button
                        :class="`report-item__sort ${sort.field === 'case.number' && 'report-item__sort--active'}`"
                        @click="$emit('sort', 'case.number')"
                    >
                        <IconSort :direction="sort.order" />
                    </button>
                </div>
            </div>

            <div class="report-item__column report-item__column--pwz">
                <div class="report-item__filter-title">Nr PWZ</div>
                <div class="report-item__filter">
                    <input type="text" class="report-list__field" v-model="filter.doctorPwz" @input="emitToParent" />
                    <button
                        :class="`report-item__sort ${sort.field === 'doctor.pwz' && 'report-item__sort--active'}`"
                        @click="$emit('sort', 'doctor.pwz')"
                    >
                        <IconSort :direction="sort.order" />
                    </button>
                </div>
            </div>
            <div class="report-item__column report-item__column--date">
                <div class="report-item__filter-title">Data zgłoszenia</div>
                <div class="report-item__filter">
                    <input
                        type="date"
                        class="report-list__field"
                        v-model="filter.caseCreatedAt"
                        @input="emitToParent"
                    />
                    <button
                        :class="`report-item__sort ${sort.field === 'case.createdAt' && 'report-item__sort--active'}`"
                        @click="$emit('sort', 'case.createdAt')"
                    >
                        <IconSort :direction="sort.order" />
                    </button>
                </div>
            </div>
            <div class="report-item__column report-item__column--chat"></div>
            <div class="report-item__column report-item__column--surgery">
                <div class="report-item__filter-title">Kod oceny chirurgicznej</div>
                <div class="report-item__filter">
                    <select
                        class="report-list__field"
                        v-model="filter.caseSurgicalEvaluationCode"
                        @change="emitToParent"
                    >
                        <option value="">Wszystkie</option>
                        <option v-for="(name, code) in surgicalEvaluation" :key="code" :value="code">{{ name }}</option>
                    </select>
                    <button
                        :class="`report-item__sort ${
                            sort.field === 'case.surgicalEvaluation.code' && 'report-item__sort--active'
                        }`"
                        @click="$emit('sort', 'case.surgicalEvaluation.code')"
                    >
                        <IconSort :direction="sort.order" />
                    </button>
                </div>
            </div>
            <div class="report-item__column report-item__column--forecast">
                <div class="report-item__filter-title">Przewidywana <br /> data zabiegu</div>
                <div class="report-item__filter">
                    <input
                        type="date"
                        class="report-list__field"
                        v-model="filter.caseExpectedSurgeryDate"
                        @input="emitToParent"
                    />
                    <button
                        :class="`report-item__sort ${sort.field === 'case.expectedSurgeryDate' && 'report-item__sort--active'}`"
                        @click="$emit('sort', 'case.expectedSurgeryDate')"
                    >
                        <IconSort :direction="sort.order" />
                    </button>
                </div>
            </div>
            <div class="report-item__column report-item__column--rating">
                <div class="report-item__filter-title">Ocena skuteczności <br /> chemioterapii</div>
                <div class="report-item__filter">
                    <select
                        class="report-list__field"
                        v-model="filter.caseChemotherapyEffectiveness"
                        @change="emitToParent"
                    >
                        <option value="">Wszystkie</option>
                        <option v-for="(name, code) in chemotherapyEffectiveness" :key="code" :value="code">{{ name }}</option>
                    </select>
                    <button
                        :class="`report-item__sort ${
                            sort.field === 'case.chemotherapyEffectiveness' && 'report-item__sort--active'
                        }`"
                        @click="$emit('sort', 'case.chemotherapyEffectiveness')"
                    >
                        <IconSort :direction="sort.order" />
                    </button>
                </div>
            </div>
            <div class="report-item__column report-item__column--last">
                <div class="report-item__filter-title">
                    Data zakończenia <br />
                    ostatniego cyklu chemii
                </div>
                <div class="report-item__filter">
                    <input
                        type="date"
                        class="report-list__field"
                        v-model="filter.caseLastChemotherapyCycleAt"
                        @input="emitToParent"
                    />
                    <button
                        :class="`report-item__sort ${
                            sort.field === 'case.lastChemotherapyCycleAt' && 'report-item__sort--active'
                        }`"
                        @click="$emit('sort', 'case.lastChemotherapyCycleAt')"
                    >
                        <IconSort :direction="sort.order" />
                    </button>
                </div>
            </div>
            <div class="report-item__column report-item__column--risk">
                <div class="report-item__filter-title">
                    Radykalność <br /> zabiegu
                </div>
                <div class="report-item__filter">
                    <select class="report-list__field" v-model="filter.caseProcedureRiskCode" @change="emitToParent">
                        <option value="">Wszystkie</option>
                        <option v-for="(name, code) in procedureRisk" :key="code" :value="code">{{ name }}</option>
                    </select>
                    <button
                        :class="`report-item__sort ${sort.field === 'case.procedureRisk.code' && 'report-item__sort--active'}`"
                        @click="$emit('sort', 'case.procedureRisk.code')"
                    >
                        <IconSort :direction="sort.order" />
                    </button>
                </div>
            </div>
            <div class="report-item__column report-item__column--options">
                <button @click="clearFilters" class="report-item__badge report-item__badge--all">
                    <IconClose class="report-item__icon" alt="" />
                    Wyczyść wszystkie filtry
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { IconFileSearch, IconSort, IconClose } from "@/components/ui/icons";
import { surgicalEvaluation, chemotherapyEffectiveness, procedureRisk } from "./ReportCodeTranslations.js"

export default {
    name: "ReportListFilters",
    components: {
        IconFileSearch,
        IconSort,
        IconClose,
    },
    props: {
        filter: {
            required: true,
            type: Object,
        },
        sort: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            folderId: "",
            surgicalEvaluation,
            chemotherapyEffectiveness,
            procedureRisk,
        }
    },
    computed: mapGetters({
        headers: "getSecuredRequestHeader",
    }),
    methods: {
        setGender(patientGender) {
            if (patientGender === this.filter.patientGender) {
                this.$emit("filter", { ...this.filter, patientGender: "" });
            } else {
                this.$emit("filter", { ...this.filter, patientGender });
            }
        },
        setCaseisReporter(caseisReporter) {
            this.$emit("filter", { ...this.filter, caseisReporter });
        },
        async setFolderId() {
            try {
                if (this.folderId.length > 3) {
                    await axios
                        .get(`${process.env.VUE_APP_API_URL}/amazon/s3/folder?fileKey=${this.folderId}`, {
                            headers: this.headers,
                        })
                        .then((response) => {
                            this.filter.folderId = response.data.folderId;
                        })
                        .catch();
                }
            } catch (error) {
                console.log(error);
            }
        },
        emitToParent() {
            this.$emit("filter", this.filter);
        },

        clearFilters() {
            // clear all object values
            const cleaned = Object.keys(this.filter).reduce((acc, key) => {
                if (typeof this.filter[key] === 'string') {
                    acc[key] = '';
                }

                if (Array.isArray(this.filter[key])) {
                    acc[key] = [];
                }
                return acc;
            }, {});

            this.$emit('filter', cleaned);
        },
    },
};
</script>

<style lang="scss">
.report-list-filters {
    background: #fff;
    transition: box-shadow 0.2s ease;
    border-bottom: 1px solid #f4f4f4;

    &.top-sticky {
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
        border-bottom: none;

        .report:first-of-type {
            border-bottom: 2px solid #36baca;
        }
    }

    .report-item {
        font-weight: bold;
        align-items: flex-end;
        transition: all 0.2s ease;

        &__column {
            justify-content: flex-end;
            align-items: flex-start;
            flex-direction: column;
        }

        &__sort {
            border: none;
            padding: 0 5px;
            color: gray;
            background: transparent;
            font-size: 15px;
            line-height: 1;

            &--active {
                color: #36baca;
            }
        }

        &__filter-title {
            font-size: 0.8em;
        }

        &__filter {
            display: flex;
            width: 100%;

            &--owner {
                grid-column: span 2;
            }

            &--sort {
                grid-column: span 2;
                display: flex;
                align-items: center;

                select {
                    width: 200px !important;
                }

                p {
                    margin: 0 15px 0 0;
                }
            }
            &--gender {
                grid-column: span 2;
                display: flex;

                label {
                    margin-right: 15px;
                }
            }
            &--search {
                grid-column: span 2;
                display: flex;
                align-items: center;

                p {
                    margin: 0 15px 0 0;
                }
            }
        }

        &__badge {
            border: none;
            color: white;
            display: inline-flex;
            align-items: center;
            padding: 5px 10px;
            border-radius: 20px;
            cursor: pointer;
            margin-right: 10px;

            > * {
                margin-right: 6px;
            }

            &--all {
                background: rgba(0, 0, 0, 0.5);
            }

            &--my {
                background: #46c0cf;
            }

            &--other {
                background: #b6b6b6;
            }
        }
    }

    .report-filter-options {
        align-items: center !important;
        padding: 15px;

        p {
            margin-top: 0;
            margin-bottom: 0;
        }
    }
}
</style>
